<template>
  <div>
    <el-table
      :data="batchList">
      <el-table-column
        prop="batchNo"
        label="批次">
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题">
      </el-table-column>
      <el-table-column
        label="开始时间">
        <template slot-scope="scope">
          {{ scope.row.startTime | moment('YYYY-MM-DD hh:mm') }}
        </template>
      </el-table-column>
      <el-table-column
        label="结束时间">
        <template slot-scope="scope">
          {{ scope.row.endTime | moment('YYYY-MM-DD hh:mm') }}
        </template>
      </el-table-column>
      <el-table-column
        label="是否开启">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.isEnabled"
            @change="handleEnableChange(scope.row.batchNo, $event)"
            active-color="#13ce66">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
      label="操作">
        <template slot-scope="scope">
          <el-button type="primary" circle icon="el-icon-edit" @click="handleUpdate(scope.row)">
          </el-button>
          <el-button type="danger" circle icon="el-icon-delete" @click="handleRmove(scope.row.id)">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'BatchList',
  computed: {
    ...mapState('voteBatchSetting', ['batchList'])
  },
  methods: {
    ...mapActions('voteBatchSetting', [
      'enableBatch',
      'disableBatch',
      'removeBatch'
    ]),
    ...mapMutations('voteBatchSetting', [
      'setDetailDialogVisible',
      'setBatchDetail'
    ]),
    handleEnableChange(batchNo, status) {
      const message = status
        ? '确认要开启此批次吗？，开启此批次，其它批次将会关闭。'
        : '确认要关闭此批次吗？';
      const action = status ? this.enableBatch : this.disableBatch;

      this.$confirm(message, '提示', { type: 'warning' }).then(() => {
        action(batchNo).then(() => {
          this.$message.success('开启成功！');
          this.$emit('refresh');
        });
      });
    },
    handleUpdate(batch) {
      this.setDetailDialogVisible(true);
      this.setBatchDetail(batch);
    },
    handleRmove(id) {
      this.$confirm('确认要删除该批次吗？', '提示', { type: 'warning' }).then(
        () => {
          this.removeBatch(id).then(() => {
            this.$message.success('删除成功！');
            this.$emit('refresh');
          });
        }
      );
    }
  }
};
</script>

<style>
</style>
